import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const AreaChartComponent = ({ data }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-[#1e1e26] border border-[#22222e] rounded-lg px-4 py-3">
          <p className="text-white font-bold mb-2" style={{ fontFamily: 'DM Mono, monospace' }}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color, fontFamily: 'DM Mono, monospace' }} className="text-sm">
              {entry.name}: {entry.name === 'Market Size' ? `$${entry.value}B` : entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="colorMarket" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#38bdf8" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#38bdf8" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorSearch" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#a78bfa" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#a78bfa" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#22222e" />
        <XAxis 
          dataKey="year" 
          stroke="#7b7a88" 
          style={{ fontFamily: 'DM Mono, monospace', fontSize: '12px' }}
        />
        <YAxis 
          stroke="#7b7a88" 
          style={{ fontFamily: 'DM Mono, monospace', fontSize: '12px' }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ fontFamily: 'DM Mono, monospace', fontSize: '12px' }}
        />
        <Area 
          type="monotone" 
          dataKey="market_size" 
          stroke="#38bdf8" 
          fillOpacity={1} 
          fill="url(#colorMarket)" 
          name="Market Size ($B)"
        />
        <Area 
          type="monotone" 
          dataKey="search_volume" 
          stroke="#a78bfa" 
          fillOpacity={1} 
          fill="url(#colorSearch)" 
          name="Search Volume Index"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AreaChartComponent;
